import { Tabs } from "antd";
import ReactJsonView from "@microlink/react-json-view";

function JSONViewer({ schema, data }) {
  const items = [
    {
      key: "schema",
      label: "JSON Schema",
      children: (
        <ReactJsonView src={schema} theme="google" iconStyle="circle" />
      ),
    },
    {
      key: "data",
      label: "Extracted Data",
      children: <ReactJsonView src={data} theme="google" iconStyle="circle" />,
    },
  ];

  return <Tabs type="card" defaultActiveKey="data" items={items} />;
}

export default JSONViewer;
